import React                                    from 'react';
import ReactDOM                                 from 'react-dom';
import axios                                    from 'axios';
import { store } from "./Redux/Store/"
import { BrowserRouter as Router }              from "react-router-dom"
import './index.css';
import App                                      from './App';

axios.interceptors.request.use( config => {
   const jwt = localStorage.getItem('jwt')
   if (jwt) {
      config.headers.Authorization = `Bearer ${jwt}`
   }
   else {
      delete config.headers.Authorization // logged out → send nothing
   }
   return config
} )

const render = () =>

   ReactDOM.render(
  // <React.StrictMode>
    <Router>
      <App />
    </Router>,
  // </React.StrictMode>,
  document.getElementById('root')
);

render()

store.subscribe(render)